import * as React from "react";
import { cn } from "../../lib/cn";

export function Button({
  className,
  variant = "primary",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center gap-3 w-auto px-7 py-4 rounded-2xl font-semibold transition-all duration-200 shadow-soft hover:shadow-softHover focus:outline-none focus:ring-2 focus:ring-brand-border";

  const variants = {
    primary: "bg-brand-orange text-white hover:bg-[#A84A22]",
    whatsapp: "bg-brand-whatsapp text-white hover:bg-[#20BA5A]",
    secondary: "bg-white text-brand-text border border-brand-border hover:bg-gray-50",
  };

  return <button className={cn(base, variants[variant], className)} {...props} />;
}
